// extracted by mini-css-extract-plugin
module.exports = {"content":"Cashiers_content__7cbHa"};